module.exports = __webpack_public_path__ + "img/co-branding-logos-intro.61f0f6ec.png";